export default {
  title: "Нуқтаҳои савдо",
  name: "Номи нуқтаи савдо",
  namingNoSpecified: "Ном муайян нашудааст",
  tradingPoint: "Нуқтаи савдо",
  addressNoSpecified: "Суроға муайян нашудааст",
  info: "Маълумот дар бораи нуқтаи савдо",
  add: {
    title: "Эҷоди нуқтаи савдо",
    noOperations: "Ягон амалиёт анҷом дода нашудааст",
  },
  historyOperation: "Таърихи чекҳо",
  employee: "Корманд",
  customer: "Харидор",
  source: "Манбаъ",
  typeOperation: "Намуди амалиёт",
  typeActivity: "Намуди фаъолият",
  writing: "Қисман баровардан",
  accrual: "Ҳисобкунии бонус",
  sumBuy: "Маблағи харид",
  sumWrite: "Маблағи қисман баровардан",
  toPay: "Барои пардохт",
  totalCashback: "Мукофоти умумӣ",
  salePopup: "Тахфиф",
  types: {
    balance_up: "Пур кардани баланс",
    balance_down: "Хароҷоти маблағ",
    tsp_approve: "Ҳисоббаробаркунӣ аз рӯи чек",
    balance_refill: "Пур кардани баланс",
    tariff_change: "Хариди тариф",
    cashback_approve: "Саёҳати муштарӣ",
    cashback_charge: "Чек. Қисман баровардани холҳо",
    certificate_charge: "Ҳисобкунӣ. Истифодаи корти туҳфа",
    certificate_debt: "Қисман баровардан. Барориши корти туҳфа",
    certificate_refund: "Баргардони маблағ барои барориши корти туҳфа",
    rc_withdraw: "Чек. Қабули холҳо",
    tsp_commission_fee: "Чек. Комиссия",
    tsp_commission_revert:
      "Иловаи маблағи нодуруст баровардашуда барои давра аз 1 апрел то рӯзи ҳисобкунӣ",
    tsp_commission_correct:
      "Ислоҳи ҳисоббаробаркуниҳо ба андозаи 1% аз холҳои қабулшуда",
    manual_commission_approve: "Чек. Ҳисоббаробаркунӣ барои комиссия",
    manual_withdraw: "Баровардани маблағ",
    cashback_decline: "Бекоркунии чек",
    rc_processing_receipts: "Чек аз терминали касса",
    cashback_approve_decline: "Бекоркунии ҳисобкунӣ барои саёҳати муштарӣ",
    partner_manual_withdraw: "Хароҷоти маблағ",
    inner_cashback_charge: "Чек. Қисман баровардани мукофот",
    inner_cashback_approve: "Ҳисоббаробаркунӣ аз рӯи чек",
    tsp_approve_payment: "Чек. Хароҷоти маблағ",
    rc_withdraw_approve: "Чек. Ҳисобкунӣ барои пардохт бо холҳо",
    withdraw_payment: "Чек. Хароҷоти маблағ",
    prodazha_top_mesta: "Хариди ҷои беҳтарин дар rcpay",
    reserving_funds_withdrawal: "Маблағ ба таври муваққатӣ нигоҳ дошта шуд",
    refund_reserved_funds_withdrawal: "Баргардонидани маблағи муваққатӣ",
    withdraw_reserved_funds: "Баровардани маблағ",
  },
  organizations: "Ширкат",
  moderationModalTitle: "Паём аз модератсия",
  clients: "муштарӣ: ",
  other: "комиссия: ",
  total: "Ҳамагӣ: ",
  draft: "Қисмнома",
  itsAppearAfterCreateShop: "Онҳо баъд аз эҷоди нуқтаи савдо пайдо мешаванд",
  inRCPay: {
    published: "Дар RC PAY нашр шудааст",
    unpublished: "Дар RC PAY нашр нашудааст",
  },
  promotion: "Пешбурд",
  openInRCPay: "Кушодан дар RC PAY",
  couldntSendShopToModeration: "Нуқтаи савдо сабт нашуд",
  shopChangesSuccessSaved:
    "Тағиротҳои нуқтаи савдо бомуваффақият захира шуданд",
  forLayoultyCreateEmployee:
    "Барои кор бо барномаи вафодорӣ бояд кассирро дар зербахши «Кассирҳо» эҷод карда, ба нуқтаи савдои мазкур зам кунед.",
  changesSendedToModeration:
    "Тағиротҳои нуқтаи савдо ба модератсия ирсол шуданд",
  someChangesNeedModeration:
    "Баъзе аз тағиротҳои воридшуда ба модератсия ниёз доранд",
  changesUpdateAfterModeration:
    "Дар корти муассиса, ки дар RC PAY намоиш дода мешавад, онҳо танҳо баъд аз санҷиш ва тасдиқи модератор нав мешаванд.",
  connectedPaymentMethod: "Ба нуқтаи савдо усулҳои пардохт пайваст шудаанд.",
  ifNeedDeleteConnectWithUs:
    "Агар зарурати нест кардани он бошад, ба дастгирии техникӣ муроҷиат кунед ",
  ifNeedDeleteConnectWithUsSuccess:
    "Почтаи электронӣ ба буфер нусхабардорӣ шуд",
  someFieldsUncorrect: "Баъзе майдонҳо нодуруст пур шудаанд",
  backToEditingToFixIt:
    "Ба таҳрир баргардед, то онҳоро ислоҳ кунед. Ё «Гузаронидан»-ро пахш кунед, агар мехоҳед бе захира кардани маълумоти нодуруст бароед.",
  wannaQuit: "Мехоҳед бароед?",
  allNotSavedChangesWillRemove:
    "Ҳамаи тағиротҳое, ки захира нашудаанд, гум мешаванд. Барои нигоҳ доштан, ба қафо баргардед.",
  cancelCreationPointModal: {
    title: "Эҷоди нуқтаи савдо бекор карда шавад?",
    subtitle:
      "Маълумоти воридшуда оид ба нуқтаи савдо захира намешавад. Барои баргаштан ба таҳрир «Қафо»-ро пахш кунед.",
  },
  moderationModal: {
    title: "Нуқтаи савдо бо муваффақият эҷод ва ба модератсия фиристода шуд",
    subtitle:
      "Барои кор бо барномаи вафодорӣ бояд кассирро дар зербахши «Кассирҳо» эҷод карда, ба нуқтаи савдои мазкур зам кунед.",
  },
  deletePromotionModal: {
    title:
      "Оё мутмаин ҳастед, ки мехоҳед нуқтаи савдоро бо хизмати фаъол пешбурд нест кунед?",
    subtitle:
      "Баъд аз несткунӣ хизматрасонии пешбурд қатъ мешавад. Маблағҳои пардохтшуда баргардонида намешаванд. Барқарор кардани маълумоти нуқтаи савдо ғайриимкон аст.",
  },
  deleteModal: {
    title: "Оё мутмаин ҳастед, ки мехоҳед нуқтаи савдоро нест кунед?",
    subtitle: "Пас аз несткунӣ барқарор кардани маълумот ғайриимкон аст.",
    shopDeleted: "Нуқтаи савдо нест шуд",
  },
  lessTariffModal: {
    title: "Шумо шумораи максималии нуқтаҳои савдоро дар тарифатон эҷод кардед",
    subtitle:
      "Барои эҷоди нуқтаҳои савдои бештар бояд дигар тариф харидорӣ кунед.",
  },
  validation: {
    specifyMailOrRemoveField:
      "Суроғаи почтаи электронӣ ворид кунед ё майдонро нест кунед",
    specifyLinkAddressOrRemove:
      "Суроғаи истинодро ворид кунед ё майдонро нест кунед",
    couldntSendShopToModeration: "Нуқтаи савдо ба модератсия фиристода нашуд",
    someImagesCouldntProcess:
      "Баъзе тасвирҳо коркард нашуданд. Кӯшиш кунед дигар тасвирҳоро бор кунед",
  },
  creationTab: {
    main: "Асосӣ",
    loyalty: "Барномаи вафодорӣ",
    addressAndOpeningHours: "Суроға ва вақти корӣ",
    contacts: "Тамосҳо",
    foto: "Акс",
  },
  stepFromTo: "Қадам {from} аз {total}",
  createShopAndContinue: "Нуқтаи савдо эҷод кунед ва идома диҳед",
  message: {
    dataSavedToDraft: "Маълумоти нуқтаи савдо ба қисмнома захира шуд",
    dataSavedAndSendToModeration:
      "Тағиротҳо захира ва ба модератсия ирсол шуданд",
    dataSuccessSaved: "Тағиротҳо бомуваффақият захира шуданд",
    fillCorrectSpecifiedFields: "Майдонҳои нишон додашударо дуруст пур кунед",
    fillCorrectAllRequiredFields: "Ҳамаи майдонҳои ҳатмиро дуруст пур кунед",
  },
  describeYourCompany:
    "Ширкати худро муфассал тавсиф кунед. Лутфан, дар матн хештегҳо (#) ва смайлҳо истифода набаред. Суроғаҳо, маълумоти тамос ва реҷаи корӣ алоҳида нишон дода мешаванд — дар варақаҳои баъдӣ.",
  willDisplayToUserInRCPay: "Ба истифодабарандагони RC PAY намоиш дода мешавад",
  activityTooltip:
    "Муассиса дар натиҷаҳои ҷустуҷӯ дар RC PAY ҳангоми филтр аз рӯи категорияҳои интихобшуда намоиш дода мешавад.",
  afterModerationEntityEditingDisable:
    "Пас аз тасдиқи модератсия таҳрири ширкати ҳуқуқӣ дастнорас мешавад. Барои тағйирот ба дастгирии техникӣ муроҷиат кунед.",
  description: "Тавсифи нуқтаи савдо",
  charsLimit: {
    min: "Ҳадди ақали рамзҳо - {minChars}",
    max: "Ҳадди аксари рамзҳо - {maxChars}",
  },
  features: "Хусусиятҳо",
  selectedFeaturesWillDisplayInCard:
    "Имконоти интихобшуда дар корти муассисаи шумо дар RC PAY ҳамчун теги намоиш дода мешаванд",
  catalogTitles: "Номи блок бо молҳо / хизматрасониҳо дар RC PAY",
  catalogTitlesTooltip:
    "Номи умумӣ барои блок бо рӯйхати молҳо / хизматрасониҳои нуқтаи савдо. Танҳо дар саҳифаи муассисаи шумо дар RC PAY истифода мешавад.",
  totalPercentReward: "Фоизи умумии мукофот",
  totalPercentRewardValue: "Фоизи умумии ҳисобкунии мукофот (аз 4 то 25).",
  rewardWillPayToClients:
    "Мизоҷон маблағро мувофиқи сенарияҳои тақсимоти мукофот мегиранд.",
  checkRewardDistribution: "Сенарияҳои тақсимоти мукофотро бинед",
  activeWait: "Таъхири ҳисобкунӣ",
  activeWaitTooltip:
    "Шумораи рӯзҳо (аз 0 то 14) пас аз хариди муштарӣ, ки баъд аз он мукофот ҳисоб мешавад",
  clientDiscount: "Тахфифи муштариёни RC PAY",
  clientDiscountTooltip:
    "Фоизи тахфиф (аз 0 то 99), ки ба муштариёни барномаи вафодории RC GROUP ҳангоми харид дар нуқтаи савдо пешниҳод мешавад",
  shopPaylable: "Нуқтаи савдо пардохт бо холҳои RC-ро қабул мекунад",
  shopPaylableDescription:
    "Муштариёни RC PAY метавонанд то 99,9% арзиши харидро бо холҳои RC пардохт кунанд",
  enteredDataNotNeedModeration:
    "Маълумоти воридшуда ба модератсия ниёз надоранд ва фавран пас аз эҷод ё таҳрир (агар ширкати ҳуқуқӣ тасдиқ шудааст) татбиқ мешаванд.",
  address: "Суроға",
  ifNoYourShopSelectNear:
    "Агар дар харита суроғаи муассисаи шумо нест, наздиктаринро интихоб кунед ва ба дастгирии техникӣ муроҷиат кунед",
  startEnteringAddress:
    "Воридкунии суроғаро оғоз кунед ва аз рӯйхат интихоб кунед",
  addressComment: "Шарҳи суроға",
  specifyWayToGetYouShop:
    "Тавзеҳ диҳед, ки чӣ тавр ба муассисаи шумо расидан мумкин аст, ё маълумоти иловагӣ ворид кунед (ихтиёрӣ)",
  period: {
    workdays: "Рӯзҳои корӣ ДУ-ҶУ",
    weekend: "Рӯзҳои истироҳат ШБ-ЯК",
    allDay: "Ҳар рӯз ДУ-ЯК",
    aroundClock: "Шабонарӯзӣ 24/7",
  },
  catalog: "Каталог",
  intervals: "Интервалҳо",
  weekdays: "Рӯзҳои ҳафта",
  selectedAllDays: "Ҳамаи рӯзҳои ҳафта интихоб шуданд",
  workHoursInOtherDays: "Соатҳои корӣ дар рӯзҳои дигар",
  workDays: "Рӯзҳои корӣ",
  workDaysMobileSubtitle:
    "Интервал ё рӯзҳои алоҳидаро интихоб кунед, вақте ки нуқтаи савдо бо як реҷа кор мекунад.",
  workDaysTooltips: [
    "Интервал ё рӯзҳои алоҳидаро интихоб кунед, вақте ки нуқтаи савдо бо як реҷа кор мекунад (масалан, ДУ-ҶУ аз 10:00 то 20:00).",
    "Сипас «Соатҳои корӣ дар рӯзҳои дигар»-ро пахш кунед ва рӯзҳоро интихоб кунед, ки дар онҳо реҷа фарқ мекунад (масалан, ШБ аз 12:00 то 16:00).",
  ],
  specifyWorkTimeInSelectedDays:
    "Соатҳои кориро дар рӯзҳои интихобшуда ворид кунед",
  publicTradingPoint: "Нуқтаи савдо дар сомонаи rcpay.ru нашр шавад",
  publicTTDescription: [
    "Нуқтаи савдо дар сомонаи rcpay.ru ва дар барномаи мобилии RC PAY дар доираи шаҳри мазкур намоиш дода мешавад.",
    "Барои нашр дар RC PAY тасдиқи модератор лозим аст. Барои бекор кардан модератсия талаб намешавад.",
  ],
  workOnline: "Нуқтаи савдо онлайн кор мекунад",
  workOnlineDescription: [
    "Хизматрасониҳо/молҳо танҳо онлайн/бо расондан пешниҳод мешаванд.",
    "Дар майдони «Суроға» суроғаи тахминиро ворид кунед — он дар корти муассиса намоиш дода намешавад, ба ҷояш калимаи «Онлайн» пайдо мешавад.",
  ],
  time: "Соатҳои корӣ",
  specifyPhoneNumberOrRemove:
    "Рақами телефон ворид кунед ё майдонро нест кунед",
  specifyMailOrRemove: "Почтаи электронӣ ворид кунед ё майдонро нест кунед",
  onlineService: "Хизматрасонии бақайдгирии онлайн",
  specifyLinkIfUseOtherServicesForOnline:
    "Агар хидматҳои омодаи бақайдгирии онлайн истифода мекунед, истинодро ворид кунед",
  linkAddress: "Суроғаи истинод",
  addSiteOrSocialMedia: "Истинод ба сомона ё шабакаҳои иҷтимоӣ илова кунед",
  linkName: "Номи истинод",
  linkNameTooltips: [
    "Номеро ворид кунед, ки чӣ гуна мехоҳед истинод дар RC PAY намоиш дода шавад. Масалан, «Харидан» ё «Захира кардан».",
    "Агар чизе ворид накунед, суроғаи истинод намоиш дода мешавад.",
  ],
  pointPhotos: "Аксҳои нуқтаи савдо",
  photosRequirements:
    "Дар сифати баландтарин, бе аломатҳои обӣ, навиштаҳо ва коллажҳо бояд бошанд",
  logo: "Логотип",
  photoRecomendation: "Тавсияҳо барои тасвир",
  logoRecomendations: [
    "Файли формати JPEG, JPG, PNG то 10 Мб, таносуби тарафҳо — 1:1",
    "Логотип, тасвири мавзӯӣ, тасвир бо номи муассиса ё аломати фирмавӣ мувофиқ аст",
    "Тасвири босифат, ки суроға, телефон ва маълумоти иловагиро дар бар намегирад",
  ],
  uploadLogo: "Бор кардани логотип",
  noClient: "Муштарӣ нест",
  giftCard: "Корти туҳфа",
  totalCashbackHints: [
    "Дар чек фоизи умумии мукофот нишон дода шудааст, аммо маблағи чек метавонад бо маблағи воқеан баровардашуда мувофиқат накунад.",
    "Ин аз он вобаста аст, ки кадом муштарӣ харид кардааст (дохилӣ ё хориҷӣ), инчунин аз тарифи ӯ.",
  ],
  previewInRCPay: "Пешнамоиш дар RC PAY",
  searchByTable: "Ҷустуҷӯ дар ҷадвал",
};
